import { RESET_ALL as RESET_ON_LOGOUT } from './common-reducer';

import { createReducer } from 'utils/redux';
import { BRAND } from 'utils/brands';

const BRANDS_FILTER_UPDATED = 'brandsFilter/BRANDS_FILTER_UPDATED';

const initialState = {
  activeFilter: BRAND
};

export function brandsFilterUpdated(filter) {
  return {
    type: BRANDS_FILTER_UPDATED,
    payload: {
      filter
    }
  };
}

export default createReducer('brandsFilter', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [BRANDS_FILTER_UPDATED]: (state, { filter }) => ({
    activeFilter: filter
  })
});
